import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setCashout } from 'services/withDraw'
import posthog from 'posthog-js'

export default function useSetCashouts() {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IGetCardsPayloadFinal) => {
            return setCashout(payload)
        },
        onSuccess: (data, variables, payload) => {
            toast.success('برداشت با موفقیت ثبت شد')
            posthog.capture('fund_withdrawal_succeeded', {
                method: 'manual_record',
                amount: (variables as any)?.amount,
                reason: (variables as any)?.reason,
                moneypool_id: (variables as any)?.moneyPool,
            })
            navigate('/funds')
        },
        onError: () => {
            posthog.capture('fund_withdrawal_failed', {
                method: 'manual_record',
            })
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
